import React, { Component } from 'react'
import { Modal, Form, Input, Button, Checkbox, Select } from 'antd'
import { api } from '../../../services'

const TYPES = [
  {
    label: 'Pdf', value: 'PDF'
  }, {
    label: 'Document', value: 'DOCUMENT'
  }, {
    label: 'Image', value: 'IMAGE'
  }, {
    label: 'Audio/Video', value: 'AUDIO_VIDEO'
  }, {
    label: 'Archive', value: 'ARCHIVE'
  }
]

const PROPERTIES = [
  {
    label: 'Can\'t be shared', value: 'CAN_NOT_BE_SHARED'
  }, {
    label: 'Can\'t be downloaded', value: 'CAN_NOT_BE_DOWNLOADED'
  }
]

class channelDirectoryEditModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      error: '',
      loading: false,
      data: {}
    }
  }

  componentDidMount () {
    api.storage.getSmartDirectory(this.props.id).then((response) => {
      this.setState({
        data: response.data.result
      })
    })
  }

  handleOk = (e) => {
    const { id, updateSmartDirectory, resetTable, form } = this.props

    e.preventDefault()

    this.setState({
      error: '',
      loading: true
    })

    form.validateFields((err, values) => {
      if (!err) {
        updateSmartDirectory(id, {
          name: values.name,
          contentTypes: values.contentTypes,
          properties: values.properties,
          matchAllTagIds: values.matchAllTagIds,
          matchAnyTagIds: values.matchAnyTagIds,
          matchNoneTagIds: values.matchNoneTagIds
        }).then((response) => {
          if (response && !response.data.error) {
            resetTable()
            this.handleCancel()
          } else {
            this.setState({
              error: response.data.error.message
            })
          }

          this.setState({
            loading: false
          })
        })
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }

  handleCancel = (e) => {
    this.setState({
      error: '',
      loading: false
    })
    this.props.closeModal()
  }

  render () {
    const { tags, status, form: { getFieldDecorator } } = this.props
    const { data, loading, error } = this.state

    const layout = {
      labelCol: {
        md: { span: 10 }
      },
      wrapperCol: {
        md: { span: 14 }
      }
    }

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        title='Edit Smart Folder'
        visible={status}
        onCancel={this.handleCancel}
        destroyOnClose
        width={380}
        footer={[
          <Button key='back' onClick={this.handleCancel}>Cancel</Button>,
          <Button key='submit' type='indigo' loading={loading} onClick={this.handleOk}>Save</Button>
        ]}
      >
        { error.length > 0 ? <div className='form__error'>{ error }</div> : '' }

        <Form onSubmit={this.handleOk} className='form'>
          <Form.Item {...layout} label='Name'>
            {getFieldDecorator('name', {
              rules: [{ required: true,
                message: 'Please input folder name',
                max: 23,
                pattern: /^[^, ][ a-zA-Z_\\-\\.0-9]*/
              }],
              initialValue: data.name
            })(
              <Input name='name' maxLength={23} />
            )}
          </Form.Item>

          <Form.Item {...layout} label='File types'>
            {getFieldDecorator('contentTypes', {
              initialValue: data.contentTypes
            })(
              <Checkbox.Group options={TYPES} />
            )}
          </Form.Item>

          <Form.Item {...layout} label='File properties'>
            {getFieldDecorator('properties', {
              initialValue: data.properties
            })(
              <Checkbox.Group options={PROPERTIES} />
            )}
          </Form.Item>

          <Form.Item {...layout} label='Matсh ALL tags'>
            {getFieldDecorator('matchAllTagIds', {
              initialValue: data.matchAllTags && data.matchAllTags.map(tag => tag.id.toString()),
              rules: [{
                type: 'array'
              }]
            })(
              <Select
                mode='multiple'
                placeholder='Select tags'
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                { tags.map(tag => <Select.Option key={tag.id.toString()}>{ tag.value }</Select.Option>) }
              </Select>
            )}
          </Form.Item>

          <Form.Item {...layout} label='Matсh ANY tags'>
            {getFieldDecorator('matchAnyTagIds', {
              initialValue: data.matchAnyTags && data.matchAnyTags.map(tag => tag.id.toString()),
              rules: [{
                type: 'array'
              }]
            })(
              <Select
                mode='multiple'
                placeholder='Select tags'
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                { tags.map(tag => <Select.Option key={tag.id.toString()}>{ tag.value }</Select.Option>) }
              </Select>
            )}
          </Form.Item>

          <Form.Item {...layout} label='Matсh NONE tags'>
            {getFieldDecorator('matchNoneTagIds', {
              initialValue: data.matchNoneTags && data.matchNoneTags.map(tag => tag.id.toString()),
              rules: [{
                type: 'array'
              }]
            })(
              <Select
                mode='multiple'
                placeholder='Select tags'
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                { tags.map(tag => <Select.Option key={tag.id.toString()}>{ tag.value }</Select.Option>) }
              </Select>
            )}
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}

export default Form.create()(channelDirectoryEditModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ChannelDirectorySmartEditModal/ChannelDirectorySmartEditModal.jsx